import { useTheme } from 'styled-components';

export const ShareIcon: React.FC<{ className?: string; color?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.279059 13.9998H11.3788C11.5339 13.9998 11.658 13.8742 11.658 13.7206V9.16968C11.658 9.01458 11.5324 8.89051 11.3788 8.89051C11.2237 8.89051 11.0997 9.0161 11.0997 9.16968V13.44H0.559821V2.90015H5.83013C5.98523 2.90015 6.10931 2.77455 6.10931 2.62097C6.10931 2.46587 5.98371 2.3418 5.83013 2.3418H0.279175C0.124077 2.3418 0 2.46739 0 2.62097V13.7208C0 13.8759 0.125476 13.9998 0.279059 13.9998Z"
        fill={theme.white}
      />
      <path
        d="M4.14072 8.56932C3.89861 9.64215 3.85246 10.7816 4.00529 11.8619C4.01891 11.9588 4.09986 12.0284 4.1967 12.0284C4.29355 12.0284 4.37526 11.9588 4.38812 11.8634C4.5296 10.8701 4.84887 9.91306 5.31038 9.09359C5.74843 8.31281 6.33326 7.63112 7.0051 7.12189C7.63835 6.63769 8.35711 6.30478 9.08119 6.15725C9.34449 6.10278 9.61609 6.07176 9.88922 6.06647L9.893 7.89106C9.893 7.96293 9.93159 8.02876 9.9959 8.06129C10.0579 8.09458 10.1336 8.09231 10.1934 8.05145L14.7916 4.17955C14.846 4.14475 14.8786 4.08271 14.8786 4.01916C14.8786 3.95334 14.8453 3.8913 14.7893 3.8565L10.1684 0.0314676C10.1087 -0.00711794 10.033 -0.0109004 9.97097 0.0239019C9.90741 0.0587048 9.86807 0.124526 9.87034 0.194132L9.87412 2.13674C9.85067 2.14279 9.82949 2.15035 9.80603 2.15792C9.71903 2.18667 9.63354 2.21618 9.53896 2.24493C8.9965 2.43861 8.46766 2.69811 7.96831 3.01588C7.00973 3.6219 6.15329 4.45716 5.49498 5.42937C4.85567 6.37055 4.3866 7.45719 4.14072 8.56932Z"
        fill={theme.white}
      />
    </svg>
  );
};
